import i18n from 'i18n'

export function getAdminMenuList() {
  const menuList = []

  return menuList
}

export default function getMenuList() {
  const adminMenuList = []

  const menuList = [
    {
      divider: true,
    },
    {
      title: i18n.t('menu.record.allRecords'),
      key: 'allRecords',
      url: '/records/all',
    },
    {
      title: i18n.t('menu.record.favorites'),
      key: 'favorites',
      url: '/records/favorites',
    },
    {
      title: i18n.t('menu.record.myRecords'),
      key: 'myRecords',
      url: '/records/mine',
      // icon: <img src={settingSVG24} alt={i18n.t('menu.group.operation')} />,
    },
    {
      title: i18n.t('menu.groups'),
      // title: 'Workspace List',
      key: 'groups',
      children: [
        {
          title: 'group1',
          key: 'group1',
          url: '/records/groups',
        },
      ],
    },
    {
      title: i18n.t('menu.categories'),
      // title: 'Workspace List',
      key: 'categories',
      children: [
        {
          title: 'category1',
          key: 'category1',
          url: '/records/categories',
        },
      ],
    },
  ]

  return {
    adminMenuList,
    menuList,
  }
}
